export const sizeMap = {
  inherit: { fontSize: 'inherit', lineHeight: 'inherit', letterSpacing: 'inherit' },
  tiny: { fontSize: '0.625rem', lineHeight: '1rem', letterSpacing: '-0.00525rem' },
  xs: { fontSize: '0.75rem', lineHeight: '1rem', letterSpacing: '-0.00525rem' },
  smd: { fontSize: '0.8rem', lineHeight: '1.25rem', letterSpacing: '-0.00525rem' },
  normal: { fontSize: '0.813rem', lineHeight: '1.25rem', letterSpacing: '-0.00525rem' }, // 13 px
  sm: { fontSize: '0.875rem', lineHeight: '1.25rem', letterSpacing: '-0.00525rem' },
  sml: { fontSize: '0.8125rem', lineHeight: '1.25rem', letterSpacing: '-0.00525rem' },
  md: { fontSize: '1rem', lineHeight: '1.5rem', letterSpacing: '-0.009rem' },
  mdl: { fontSize: '1.375rem', lineHeight: '1.75rem', letterSpacing: '-0.02338rem' },
  lg: { fontSize: '1.75rem', lineHeight: '2.25rem', letterSpacing: '-0.03325rem' },
  vlg: { fontSize: '2.2rem', lineHeight: '1.75rem', letterSpacing: '-0.017rem' }
  // Add more sizes as needed
}
